/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import uuid from 'node-uuid';
import {Form, FormGroup, FormControl, ControlLabel} from 'react-bootstrap';
import {Glyphicon, Modal, Label, Button, Panel, ListGroup, ListGroupItem, Grid, Row, Col, Image, Checkbox} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import ActionResult from '../../stores/ActionResult';
import UserStore from '../../stores/UserStore';
import APIActions from '../../actions/apiActions';
import ProductStore from '../../stores/ProductStore';
import AppConstants from '../../constants/AppConstants';
import UIHelpers from '../../library/UIHelpers';
import PinEditModal from './PinEditModal.react';
import DataHelpers from '../../library/DataHelpers';

const DIGITAL_INPUTS_TABLE_NAME = "Digital PINs";
const ANALOGUE_INPUTS_TABLE_NAME = "Analogue inputs";
const VOLT_INPUTS_TABLE_NAME = "Volt PIN labels";


export default class ProductGroupedChannelList extends React.Component {
    constructor(props) {
        super(props);

        this.groupSet = this.groupSet.bind(this);
        this.buildGroupSet = this.buildGroupSet.bind(this);

        console.log("[ProductGroupedChannelList] - initialisation");
        this.state = {
          dirty : false
        };
    }

    makeEditLink(pin,group) {
      return (<a href="#" onClick={()=>this.props.editPin(pin,group)} title="Edit"><Glyphicon glyph="pencil" style={{color:"blue"}}/></a>);
    }

    makeDeleteLink(pin) {
      return (<a href="#" onClick={()=>this.props.deletePin(pin)} title="Delete"><Glyphicon glyph="remove" style={{color:"red"}}/></a>);
    }

    movePin(group,pin,offset,pins,i) {
        console.log("MOVE PIN: ", pin, offset);
        var target = pins[i + offset];

        var to = target.order[group] ;
        target.order[group] = pin.order[group];
        pin.order[group] = to ;
        this.setState({dirty : true});
    }

    makeMoveUp(group,pin,pins,i) {
        return (<a href="#" onClick={()=>this.movePin(group,pin,-1,pins,i)} title="Move Up"><Glyphicon glyph="arrow-up"/></a>);
    }

    makeMoveDown(group,pin,pins,i) {
        return (<a href="#" onClick={()=>this.movePin(group,pin,1,pins,i)} title="Move Down"><Glyphicon glyph="arrow-down"/></a>);
    }

    groupSet(product) {
        var groups = {} ;
        for (let i = 0; i < product.pins.length; ++i) {
          let pin = product.pins[i];

          if (!pin.pinGroup || pin.pinGroup === "") {
              if (!groups["-- Undefined --"]) {
                groups["-- Undefined --"] = {name : "-- Undefined --", pins: []};
              }
          }
          else {
            pin.pinGroup.split(',').forEach((p) => {
                if (!groups[p.trim()]) {
                    groups[p.trim()] = {name: p.trim(), pins: []} ;
                }
            });
          }
        }

        if (product.pins.length === 0) {
            groups["-- Undefined --"] = {name : "-- Undefined --", pins: []};
        }

        return groups;
    }


    makeTableOfPins(pinGroupName,pins) {
        var isAdmin = UserStore.isAdministrator();

        var rows = [];
        for (let i = 0; i < pins.length; ++i)
        {
            let pin = pins[i];

            if (pin.unused != "true") {
                let ledClass = DataHelpers.pinLedColourClass(pin);
                let ledPart = pin.type === "digital" ? <div className={ledClass} /> : <div />;
                let zeroOn = pin.type === "digital" ? <div><Checkbox validationState="success" checked={pin.zeroOn || false} /></div> : <div />;
                rows.push(<tr key={i}>
                    <td>{pin.channel}</td>
                    <td>{pin.type}</td>
                    <td>{pin.title}</td>
                    <td>{pin.desc}</td>
                    <td>{pin.pinGroup || ""}</td>
                    <td>{ledPart}</td>
                    <td>{zeroOn}</td>
                    {isAdmin ? (<td>
                            {i > 0 && this.makeMoveUp(pinGroupName,pin,pins,i)}{' '}
                            {i < (pins.length-1) && this.makeMoveDown(pinGroupName,pin,pins,i)}{' '}
                            {this.makeEditLink(pin,pinGroupName)}{' '}
                            {this.makeDeleteLink(pin)}
                            </td>) : <td></td>}
                    </tr>);
            }
        }

        // Add a row containing an "add" link
        if (isAdmin) {
            rows.push(
                <tr key={-1}><td colSpan="8" style={{color:"blue"}}>
                <a href="#" onClick={()=>this.props.addPin(pinGroupName)}>
                <Glyphicon glyph="plus"/>{' Add'}
                </a></td></tr>);
        }

        var colHeaders = <tr><th>#</th><th>Type</th><th>Title</th><th>Description</th><th>Group</th><th>LED</th><th>Zero ON</th><th></th></tr>;
        return (
            <div>
                <Table striped bordered condensed hover>
                    <thead>
                        <tr><th colSpan="8" className="text-center pin-group-header">{pinGroupName}</th></tr>
                        {colHeaders}
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </Table>
            </div>
        );
    }

    buildGroupSet() {
        var product = this.props.product ;
        var groups = this.groupSet(product) ;

        for (let i = 0; i < product.pins.length; ++i)
        {
          let pin = product.pins[i];

          var pg = pin.pinGroup || "-- Undefined --";
          pg.split(',').forEach((p) => {
              var gn = p.trim() ;
              var grp = groups[gn];
              if (grp) {
                  grp.pins.push(pin);
              }
              else {
                  groups[gn] = {name: gn, pins: []};
              }
          });
        }

        return groups ;
    }

    assignOrdering(groups) {
        var keys = Object.keys(groups) ;
        for (var k in keys) {
            var key = keys[k];
            var g = groups[key];
            var pins = g.pins ;
            for (var pi in pins) {
                var pin = pins[pi];
                if (!pin.order) {
                    pin.order = {};
                }

                if (pin.order[g.name] === undefined) {
                    var nid = pins.reduce((m,v) => {
                        if (v.order && v.order[g.name] !== undefined) {
                            return Math.max(v.order[g.name],m);
                        }
                        return m ;
                    }, -1);
                    pin.order[g.name] = nid + 1;
                }
            }

            // console.log("GROUP ORDER: ", g.name, g) ;
        }
    }

    pinSort(groups) {
        var keys = Object.keys(groups) ;
        for (var k in keys) {
            var key = keys[k];
            var g = groups[key];
            g.pins.sort((a,b) => {
                if (a.order && b.order && (a.order[g.name] !== undefined) && (b.order[g.name] !== undefined)) {
                    var v1 = a.order[g.name];
                    var v2 = b.order[g.name];
                    if (v1 < v2) {
                        return -1 ;
                    }
                    else if (v1 === v2) {
                        return 0 ;
                    }
                    else {
                        return 1 ;
                    }
                }
                else if (a.order && a.order[g.name] !== undefined) {
                    return -1 ;
                }
                else {
                    return 1 ;
                }
            });

            // console.log("GROUP SORT: ", g.name, g.pins) ;
        }
    }

    renderGroups() {
        // Split pins into groups
        var groups = this.buildGroupSet() ;
        this.assignOrdering(groups) ;
        this.pinSort(groups);

        var keys = Object.keys(groups) ;
        var self = this ;
        return (
            <div>
                { keys.map((k) => {
                    var group = groups[k];
                    return self.makeTableOfPins(group.name,group.pins);
                })}
            </div>
        );
    }

    render() {
        var isAdmin = UserStore.isAdministrator();
        return (
            <div>
                {this.renderGroups()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/products/productGroupedChannelList.js